import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { LOGIN_ROUTE, USER_AVATAR } from '../../../utils/constants';
import { RootState } from '../../../store/appStore';
import { setProfileModal } from '../../../store/slices/configSlice';
import { logoutUser } from '../../../services/Authentication';
import { removeUser } from '../../../store/slices/userSlice';
import { ProfileType } from '../../../types';
import LoaderButton from '../../utils/LoaderButton';
import { useAppDispatch, useAppSelector } from '../../../utils/hooks';

const Profile = ({ userName, userEmail, setShowMobileMenu }: ProfileType) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [isDisableButton, setDisableButton] = useState(false);
  const showProfileModal = useAppSelector(
    (store: RootState) => store.config.showProfileModal
  );
  const handleProfileClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    dispatch(setProfileModal(!showProfileModal));
  };
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };
  const handleLogout = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setDisableButton(true);
    logoutUser()
      .then((data) => {
        dispatch(removeUser());
        setShowMobileMenu?.(false);
        setDisableButton(false);
        navigate(LOGIN_ROUTE);
      })
      .catch(() => {
        setDisableButton(false);
      });
  };
  return (
    <div className='relative mr-2'>
      <div
        data-testid='avatar'
        className='relative flex items-center cursor-pointer'
        onClick={handleProfileClick}>
        <img
          className='w-12 h-12 rounded-full'
          src={USER_AVATAR}
          alt='avatar'
        />
        <span className='top-0 left-7 absolute  w-3.5 h-3.5 bg-green-400 border-2 border-white dark:border-gray-800 rounded-full'></span>
        <svg
          className='h-5 w-5 flex-none text-gray-400'
          viewBox='0 0 20 20'
          fill='currentColor'
          aria-hidden='true'>
          <path
            fillRule='evenodd'
            d='M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z'
            clipRule='evenodd'
          />
        </svg>
      </div>
      <div
        className={`z-10 bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600 absolute ${
          !showProfileModal ? 'hidden' : ''
        }`}
        data-testid='modal'
        onClick={handleModalClick}>
        <div className='px-4 py-3 text-sm text-gray-900 dark:text-white'>
          <div>{userName}</div>
          <div className='font-medium truncate'>{userEmail}</div>
        </div>
        <div className='py-1'>
          <button
            className={`block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white text-left w-full ${
              isDisableButton ? 'cursor-not-allowed' : ''
            }`}
            data-testid='logout'
            onClick={handleLogout}
            disabled={isDisableButton}>
            {isDisableButton && <LoaderButton />}
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
